__webpack_require__.p = "https://bs.fast.ax/build/greenlotto-ng/1768319387/";